import { paths } from "config/paths";

export const getAccountRecoveryPath = ({
	accountSlug,
	isPartnerManaged,
}: {
	accountSlug: string | undefined;
	isPartnerManaged: boolean;
}) =>
	isPartnerManaged
		? paths.accountName.settings.managedAccountRecovery(accountSlug)
		: paths.accountName.settings.editSubscription(accountSlug);
